'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('<', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-parse/lib/locate/tag.js
// module id = 239
// module chunks = 168707334958949